<template>
    <el-form :model="rule" :rules="rules" ref="forms" class="demo-ruleForm" label-width="100px">
        <el-form-item label="固件名称" prop="name">
            <el-input placeholder="请输入固件名称" v-model="rule.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="固件类型" prop="type">
            <el-select v-model="rule.type" placeholder="请选择">
                <el-option value="" label="请选择"></el-option>
                <el-option v-for="x in typeList" :key="x" :value="x" :label="x"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="版本号" prop="version">
            <el-input placeholder="请输入版本号" v-model="rule.version"  @input="handleInput" clearable></el-input>
        </el-form-item>
        <el-form-item v-if="rule.id==0" label="选择固件">
            <!-- <el-upload action="">
                <el-button type="success">点击上传</el-button>
            </el-upload> -->
            <input type="file" name="file" @change="getFile($event)">
        </el-form-item>
        <el-form-item label="固件型号" prop="romModel">
            <el-select v-model="rule.romModel" placeholder="请选择">
                <el-option value="" label="请选择"></el-option>
                <el-option v-for="x in selectList" :key="x.id" :value="x.id" :label="x.model"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submit">提交</el-button>
            <el-button @click="block">返回</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    export default {
        data() {
            return {
                name: 'edit',
                typeList:[],
                selectList:[],
                rule: {
                    id: 0,
                    name: '',
                    type: '',
                    version: '',
                    file: [],
                    romModel:'',
                },
                rules: {
                    name: { required: true, message: '请输入固件名称' },
                    type: {required: true, message: '请选择类型'},
                    version: {required: true, message: '请输入版本号'},
                    file: {required: true, message: '请上传文件'},
                    romModel: {required: true, message: '请选择设备型号'},
                },
            }
        },
        beforeCreate() {
            this.$http.get('/manage/rom-model/list').then(data=> {
                this.selectList = data['data']['data'];
            })
        },
        async created() {
            this.$http.get('/manage/firmH06/types').then(data=> {
                this.typeList = data['data']['data'];
            });
            if(this.$route.params.id) {
                console.log(this.$store.state.editInfo);
                if(!this.$store.state.editInfo) {
                    this.$router.push('../index');
                }else {
                    this.rule = this.$store.state.editInfo;
                    console.log('ceshji',this.rule)
                }
            }
        },
        methods: {
            submit() {
                this.$refs['forms'].validate(valid => {
                    if(valid) {
                        let headers = {
                            'Content-Type': 'multipart/form-data'
                        };
                        let formData = new FormData();
                        formData.append('id',this.rule.id);
                        formData.append('name',this.rule.name);
                        formData.append('type',this.rule.type);
                        formData.append('version',this.rule.version);
                        formData.append('romModel',this.rule.romModel);
                        
                        if(this.rule.id == 0) {
                            formData.append('file',this.rule.file);
                        }
                        if(this.rule.id == 0) {
                            this.$http.post('/manage/firmH06/add',formData,{headers:headers}).then(rs => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.push('../index');
                                }else {
                                    //this.rule.file = '';
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }else {
                            this.$http.post('/manage/firmH06/edit',formData,{headers:headers}).then(rs => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.push('../index');
                                }else {
                                    this.rule.file = '';
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }
                    }
                });
            },
            block() {
                this.$router.push('../index');
            },
            getFile(event){
                var file = event.target.files;
                for(var i = 0;i<file.length;i++){
                    //    上传类型判断
                    var imgName = file[i].name;
                    var idx = imgName.lastIndexOf(".");  
                    if (idx != -1){
                        var ext = imgName.substr(idx+1).toUpperCase();   
                        ext = ext.toLowerCase(); 
                        this.rule.file = file[i];
                    }
                }
            },
            handleInput(value) {
            // this.version = value.toString().replace(/\D/g, '').slice(0, 3);
            }
        }
    }
</script>